import { FilterListRounded } from "@mui/icons-material";
import {
  Badge,
  Box,
  Button,
  IconButton,
  Menu,
  SxProps,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import { useState } from "react";

interface Props {
  options: FilterMenuOption[];
  selectedValue: string | undefined;
  onChange: (selectedValue: string | undefined) => void;
  disabled?: boolean;
  hideLabel?: boolean;
  sx?: SxProps;
  buttonProps?: {
    sx?: SxProps;
  };
}

interface FilterMenuOption {
  label: string;
  value: string;
}

const FilterMenu = (props: Props) => {
  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null);
  const value = props.selectedValue ?? "all";

  function handleChange(selectedValue: string | null) {
    // Ignore deselections
    if (selectedValue == null) {
      return;
    }

    if (selectedValue === "all") {
      props.onChange(undefined);
      return;
    }

    props.onChange(selectedValue);
  }

  return (
    <>
      <Box sx={{ ...props.sx }}>
        <Badge color="primary" variant="dot" invisible={props.selectedValue === undefined}>
          {props.hideLabel ? (
            <IconButton
              variant="tertiary"
              onClick={(e) => setMenuAnchor(e.currentTarget)}
              disabled={props.disabled}
              sx={{ ...props.buttonProps?.sx }}
            >
              <FilterListRounded />
            </IconButton>
          ) : (
            <Button
              variant="tertiary"
              startIcon={<FilterListRounded />}
              onClick={(e) => setMenuAnchor(e.currentTarget)}
              disabled={props.disabled}
              sx={{ textWrap: "nowrap", ...props.buttonProps?.sx }}
            >
              {[undefined, "all"].includes(value) ? "Filter" : "1 Filter"}
            </Button>
          )}
        </Badge>
      </Box>

      <Menu
        anchorEl={menuAnchor}
        open={Boolean(menuAnchor)}
        onClose={() => setMenuAnchor(null)}
        slotProps={{ paper: { sx: { minWidth: 200 } } }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
      >
        <ToggleButtonGroup
          orientation="vertical"
          variant="menu"
          exclusive
          value={value}
          onChange={(_, value) => handleChange(value)}
          sx={{ minWidth: "100%" }}
        >
          <ToggleButton value="all">
            <Typography>All</Typography>
          </ToggleButton>

          {props.options.map((x) => (
            <ToggleButton key={x.value} value={x.value}>
              <Typography>{x.label}</Typography>
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Menu>
    </>
  );
};

export { FilterMenu };
